import { productListDescriptionFactory } from './description';
import { productListTitleFactory } from './title';
import { productListSocialMetadataFactory } from './socialMetadata';

const productList = {
  descriptionFactory: productListDescriptionFactory,
  socialMetadataFactory: productListSocialMetadataFactory,
  titleFactory: productListTitleFactory,
};

export default productList;
